import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, ICreateProviderDto, IProviderInfoDto } from '@/dtos';

export type CreateProviderDto = Partial<ICreateProviderDto>;
export type CreatedProviderDto = Partial<IProviderInfoDto>;

const useCreateProviderQuery = () => {
  const { mutateAsync } = useMutation((providerDto: CreateProviderDto) =>
    api.post<CreatedProviderDto>(API_URL.PROVIDERS, {
      facility_name: providerDto?.facility_name,
      ...providerDto?.addresses?.length ? {addresses: providerDto?.addresses}: {},
    })
  );

  const createProvider = useCallback(async (providerDto: CreateProviderDto): Promise<CreatedProviderDto> => {
    const response = await mutateAsync(providerDto);
    return response.data;
  }, [mutateAsync]);

  return {
    createProvider,
  };
};

export default useCreateProviderQuery;
